import axios from 'axios';
import { SERVICES } from '@shared/constants/apiConfig';
import { getError } from '@shared/utils/helpers';
import { Notistack } from '@shared/components/Notistack/Notistack';

export const requestRemoveRoundRobin = async (disableAlert = false) => {
  try {
    await axios.post(`/${SERVICES.USER}/round-robin/remove`);
  } catch (err) {
    if (!disableAlert) {
      Notistack.generalError(getError(err));
    }
  }
};

export const requestAddRoundRobin = async () => {
    try {
      await axios.post(`/${SERVICES.USER}/round-robin/add`);
    } catch (err) {
      Notistack.generalError(getError(err));
    }
};

export const requestRemoveSDRRoundRobin = async (disableAlert = false) => {
  try {
    await axios.post(`/${SERVICES.USER}/round-robin/sdr/remove`);
  } catch (err) {
    if (!disableAlert) {
      Notistack.generalError(getError(err));
    }
  }
};

export const requestAddSDRRoundRobin = async () => {
    try {
      await axios.post(`/${SERVICES.USER}/round-robin/sdr/add`);
    } catch (err) {
      Notistack.generalError(getError(err));
    }
};

export const requestRemoveTitlesRoundRobin = async (disableAlert = false) => {
  try {
    await axios.post(`/${SERVICES.USER}/round-robin/titles/remove`);
  } catch (err) {
    if (!disableAlert) {
      Notistack.generalError(getError(err));
    }
  }
};

export const requestAddTitlesRoundRobin = async () => {
  try {
    await axios.post(`/${SERVICES.USER}/round-robin/titles/add`);
  } catch (err) {
    Notistack.generalError(getError(err));
  }
};